import React from "react";

// IMAGE IMPORTS
import blog08 from "../../../images/blog/blog3.jpg";
import { Link } from "react-router-dom";
import CommentForm from "../CommentForm";
import RelatedBlog from "../RelatedBlog";
import ItemDetailsContent from "./ItemDetailsContent";
const DataIntel: React.FC = () => {
  return (
    <section className="blog_details_section pt-70">
      <div className="container">

        {/* MAIN IMAGE */}
        <div className="single-item-image mb-70">
          <img src={blog08} alt="Blog" />
        </div>

        {/* HEADER META */}
        <ItemDetailsContent />

        {/* CONTENT ROW */}
        <div className="row mt-none-30 g-0 align-items-center">
          <div className="col-lg-12  container">

            <div className="blog_details_content">

              {/* AUDIO BUTTON */}
              {/* <div className="post_audio">
                <button className="audio_play_btn xb-border" type="button">
                  <i className="fas fa-play"></i>
                  <span className="time">6:24</span>
                  <span>Listen to this article!</span>
                </button>
              </div> */}

              {/* MAIN HEADING */}
              <h3 className="item_details_info_heading mb-35">
                Intelligence that turns information into informed action
              </h3>

              {/* <div className="row mb-35 mt-none-30">
                <div className="col-md-6 col-sm-6 mt-30">
                  <div className="single-item-image">
                    <img src={blog09} alt="Blog" />
                  </div>
                </div>
                <div className="col-md-6 col-sm-6 mt-30">
                  <div className="single-item-image">
                    <img src={blog10} alt="Blog" />
                  </div>
                </div>
              </div> */}

              <p>
               At our AI SaaS and data solutions company, we design intelligence frameworks that help businesses move from data overload to data confidence. By combining analytics, automation, and AI-driven insight, we enable organizations to extract meaning from complex datasets without manual effort.
              </p>

              <p className="mt-20">
               Rather than focusing only on historical reporting, our solutions deliver forward-looking intelligence. We help teams understand patterns, anticipate outcomes, and respond to change faster. The result is a smarter, more connected organization where data supports every strategic and operational decision.
              </p>
              <p className="mt-20">
             Our work is guided by business priorities, not just technology. Every data intelligence solution is tailored to ensure insights are practical, accessible, and aligned with real-world objectives.
              </p>

              {/* VIDEO EMBED */}
              <div className="row mb-45 align-items-center mt-60">
                <div className="col-md-6 mt-30">
                  <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/xUrSXSoTQCk?si=7fxaPqRChD3A_vIe" title="YouTube video player"  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
                </div>

                <div className="col-md-6 mt-30">
                  <ul className="iconlist_block">
                    <li><span className="iconlist_text">Data Unification & Management.</span></li>
                    <li><span className="iconlist_text">Insight-Driven Analytics.</span></li>
                    <li><span className="iconlist_text">Real-Time Intelligence Delivery.</span></li>
                    <li><span className="iconlist_text">Predictive Intelligence Models.</span></li>
                    <li><span className="iconlist_text">Scalable Data Architecture.</span></li>
                    <li><span className="iconlist_text">Decision-Ready Dashboards.</span></li>
                  </ul>
                </div>
              </div>

              <h3 className="item_details_info_heading mb-20 mt-60">
               Making Data Work for Your Business
              </h3>

              <p className="mb-40">
               True intelligence is not about collecting more data—it’s about using the right data at the right time. AI-powered data systems continuously analyze information as it flows in, revealing opportunities and risks before they impact the business.<br></br>
                By unifying data sources and applying machine learning, our solutions create a single source of truth that teams can trust, act on, and scale with confidence.
              </p>
              

              {/* IMAGE + LIST */}
             

              <h3 className="item_details_info_heading mb-25">3 Business Outcomes of Data Intelligence</h3>

              <ul className="iconlist_block numlist_block list-unstyled">
                <li><span className="iconlist_text">1. Clarity Across Operations.</span></li>
                <li><span className="iconlist_text">2. Faster Strategic Response.</span></li>
                <li><span className="iconlist_text">3. Smarter, Sustainable Growth.</span></li>
              </ul>

              {/* AUTHOR BLOCK */}
              {/* <div className="post-block-wrap mb-50">
                <div className="postabmin_block xb-border ul_li">

                  <div className="admin_image">
                    <img src={avatar1} alt="Author" />
                  </div>

                  <div className="admin_content">
                    <h4 className="admin_name">Aiden Brooks</h4>
                    <span className="admin_designation">Content Manager</span>
                    <p>A content editor plays a pivotal role in shaping and refining digital content...</p>

                    <ul className="social_icons_blocks list-unstyled ul_li">
                      <li><Link to="/blog-details"><i className="fab fa-facebook-f"></i></Link></li>
                      <li><Link to="/blog-details"><i className="fab fa-instagram"></i></Link></li>
                      <li><Link to="/blog-details"><i className="fab fa-linkedin-in"></i></Link></li>
                    </ul>
                  </div>

                </div>
              </div> */}

              {/* TAGS + SOCIAL */}
              <div className="row mt-none-30">
                {/* <div className="col-md-6 mt-30">
                  <ul className="tags_block list-unstyled">
                    <li><Link className="xb-border" to="/blog-details">AI Solutions</Link></li>
                    <li><Link className="xb-border" to="/blog-details">Data Science</Link></li>
                    <li><Link className="xb-border" to="/blog-details">SaaS</Link></li>
                  </ul>
                </div> */}

                {/* <div className="col-md-6 mt-30">
                  <ul className="social_icons_block list-unstyled ul_li justify-content-md-end">
                    <li><Link className="xb-border" to="/blog-details"><i className="fab fa-facebook-f"></i></Link></li>
                    <li><Link className="xb-border" to="/blog-details"><i className="fab fa-twitter"></i></Link></li>
                    <li><Link className="xb-border" to="/blog-details"><i className="fab fa-linkedin-in"></i></Link></li>
                    <li><Link className="xb-border" to="/blog-details"><i className="fab fa-instagram"></i></Link></li>
                    <li><Link className="xb-border" to="/blog-details"><i className="fas fa-share-alt"></i></Link></li>
                  </ul>
                </div> */}
              </div>

              {/* COMMENTS AREA */}
              {/* <CommentsArea /> */}

              {/* COMMENT FORM */}
              <CommentForm />

              {/* SUBSCRIBE BOX */}
              {/* <NewsletterBox /> */}
            </div>
          </div>
          {/* <BlogSidebar /> */}
        </div>

        <RelatedBlog/>

      </div>
    </section>
  );
};

export default DataIntel;
